import {
  CurrentWorkSessionResponse,
  ScheduleEntry,
  ScheduleQuery,
  ScheduleResult,
  UpdateScheduleEntryDto,
  UpsertScheduleBreakDto,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";

/**
 * Breaks are ScheduleEntry rows of type BREAK — they have no business object of their own.
 * These routes replaced PUT/DELETE /time-entries/break in the ScheduleEntry refactor.
 */
export const scheduleApi = {
  /**
   * The calendar read. Omit `technicianIds` for every technician; pass one for a single column.
   * Replaced GET /appointments/technicians and GET /appointments/technician/:id, which returned
   * no tasks and left break projection to the client.
   */
  /** The caller's one open work session (phase + timer anchor), or `{ session: null }`. */
  getCurrentWorkSession: () =>
    apiClient.get<CurrentWorkSessionResponse>("/schedule/work-session/current"),

  getSchedule: (params: Partial<ScheduleQuery>) =>
    apiClient.get<ScheduleResult>("/schedule", {
      params,
      // Repeat-format arrays: `technicianIds=1&technicianIds=2`. Axios defaults to
      // `technicianIds[]=1`, which Express's qs parser happens to accept but which does not match
      // the documented query shape — and would break outright behind any proxy or gateway that
      // parses query strings strictly.
      paramsSerializer: {
        indexes: null,
      },
    }),

  /**
   * Move, resize or re-assign one block. Addressed by **schedule-entry** id — `response.schedule.id`
   * — not the owner's id; they are different numbers for the same appointment.
   *
   * The server dispatches on the entry's immutable `type` to the owning use-case, so one payload
   * shape serves all four kinds and a drag handler never branches on what it is dragging.
   */
  updateEntry: (entryId: number, dto: UpdateScheduleEntryDto) =>
    apiClient.patch<ScheduleEntry>(`/schedule/${entryId}`, dto),

  upsertBreak: (dto: UpsertScheduleBreakDto) =>
    apiClient.put<ScheduleEntry>("/schedule/break", dto),

  deleteBreak: (id: number) => apiClient.delete(`/schedule/break/${id}`),
};
